import { render, staticRenderFns } from "./childbusinessinfo.vue?vue&type=template&id=632ce033"
import script from "./childbusinessinfo.vue?vue&type=script&lang=js"
export * from "./childbusinessinfo.vue?vue&type=script&lang=js"
import style0 from "./childbusinessinfo.vue?vue&type=style&index=0&id=632ce033&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports